"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/toggle/index.ts
var toggle_exports = {};
__export(toggle_exports, {
  default: () => Toggle_default
});
module.exports = __toCommonJS(toggle_exports);
var import_index2 = require("./index.css");

// src/toggle/Toggle.tsx
var import_classnames2 = __toESM(require("classnames"));
var import_react2 = require("react");

// src/common/constants/index.ts
var componentSizeToBodyTextSizeMap = {
  l: "body-one",
  m: "body-two",
  s: "body-three",
  xs: "body-four"
};

// src/typography/index.ts
var import_index = require("./index.css");

// src/typography/Typography.tsx
var import_classnames = __toESM(require("classnames"));
var import_react = require("react");

// ../component-library-styles/typography.module.scss
var typography_module_default = {
  "heading-xxl": "typography-module__heading-xxl___t4Iml",
  "heading-xl": "typography-module__heading-xl___wbMqr",
  "heading-lg": "typography-module__heading-lg___GUMI7",
  "heading-md": "typography-module__heading-md___I661h",
  "heading-sm": "typography-module__heading-sm___2Jm-k",
  "heading-xs": "typography-module__heading-xs___FJljd",
  "body-one": "typography-module__body-one___hKZXX",
  "body-two": "typography-module__body-two___Sa-Eb",
  "body-three": "typography-module__body-three___FIk3k",
  "body-four": "typography-module__body-four___vI1SQ",
  "overline-one": "typography-module__overline-one___rXzIm",
  "overline-two": "typography-module__overline-two___WG6bF",
  "overline-three": "typography-module__overline-three___UK5T-",
  "strong": "typography-module__strong___jtYq4",
  "extra-strong": "typography-module__extra-strong___9SBuV",
  "em": "typography-module__em___2kNMg",
  "figcaption": "typography-module__figcaption___cHscw"
};

// src/typography/Typography.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Typography = ({
  semanticTag,
  visualAppearance,
  children,
  className,
  style,
  id,
  ...props
}) => {
  const Tag = semanticTag;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    Tag,
    {
      id,
      className: (0, import_classnames.default)(typography_module_default[visualAppearance], className),
      style,
      ...props,
      children
    }
  );
};
var Typography_default = (0, import_react.memo)(Typography);

// src/toggle/toggle.module.scss
var toggle_module_default = {
  "toggle": "toggle-module__toggle___LV5VJ",
  "switch": "toggle-module__switch___5joHd",
  "toggle-l": "toggle-module__toggle-l___TqsyQ",
  "toggle-m": "toggle-module__toggle-m___t07Kr",
  "toggle-s": "toggle-module__toggle-s___yd10Z",
  "toggle-xs": "toggle-module__toggle-xs___BLXS1",
  "toggle-right": "toggle-module__toggle-right___oDIBk"
};

// src/toggle/Toggle.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var Toggle = ({
  id,
  checked,
  onChange,
  name,
  value,
  label,
  disabled = false,
  position = "left",
  size = "m",
  ...HTMLAttributes2
}) => {
  const bodyTextSize = componentSizeToBodyTextSizeMap[size];
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
    "label",
    {
      className: (0, import_classnames2.default)(
        toggle_module_default.toggle,
        toggle_module_default[`toggle-${size}`],
        position === "right" && toggle_module_default["toggle-right"]
      ),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("div", { id, children: [
          /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
            "input",
            {
              type: "checkbox",
              name,
              value,
              checked,
              onChange,
              disabled,
              ...HTMLAttributes2
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("span", { className: toggle_module_default.switch, children: [
            /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("i", { className: "fa-solid" }),
            /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", {})
          ] })
        ] }),
        label && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(Typography_default, { semanticTag: "span", visualAppearance: bodyTextSize, children: label })
      ]
    }
  );
};
var Toggle_default = (0, import_react2.memo)(Toggle);
//# sourceMappingURL=index.js.map